import { TrainingService } from './../../service/training.service';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { HierarchyService } from '../../service/hierarchy.service';

@Component({
  selector: 'app-training-area',
  templateUrl: './training-area.component.html',
  styleUrls: ['./training-area.component.css']
})
export class TrainingAreaComponent implements OnInit {
   _agents;
   _filteredAgents;
   _filterTmp;
   show = false;

  @ViewChild('query') queryInput: ElementRef;

  constructor(private hierarchyService: HierarchyService) {
  }

  ngOnInit() {
    this._filterTmp = this._filteredAgents = this._agents = [];
  }

  @Input()
  set agents(value) {
    // console.log(value)
    this._filterTmp = this._filteredAgents = this._agents = value;
    if (this.queryInput) {
      this.queryInput.nativeElement.value = '';
    }
  }

  filter(query: string) {
      this._filteredAgents = (query.length > 0 ?
        this._filterTmp.filter((d)  => {
          const name = [d.firstName, d.lastName, d.username].join(' ');
           if ( name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
             return d;
           }
        }) :
        this._filterTmp);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/training-area/training-area.component.ts